import Cookies from "js-cookie";
import { isJwtExpired, clearTokenSession } from "./authSession";

export const validateToken = async () => {
  const token = Cookies.get("runner_app");
  if (!token) return false;

  if (isJwtExpired(token)) {
    clearTokenSession();
    return false;
  }

  return true;
};
